exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3ydpW{padding-left:20px;padding-right:20px;float:left;position:relative;width:100%;background-image:linear-gradient(80deg,#00857a,#006a75)!important;background-color:#008489!important;box-shadow:0 1px 10px rgba(0,0,0,.1)!important;margin-bottom:20px;z-index:1;height:auto}._2rVw2{margin:0 auto;padding:0 0 40px;max-width:1080px}._4zDOk{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._1t4MT,._1vJPL,._2mCtN{position:relative}._2mCtN{display:block;height:245px;-webkit-backface-visibility:hidden;backface-visibility:hidden;vertical-align:middle;overflow:hidden;background-color:#d8d8d8;text-align:center}._1vCWJ{position:absolute;right:0;left:0;bottom:0;top:0}._2f9aJ{height:100%;width:auto}._3WyXw{padding-top:8px}._2T3KM{cursor:pointer;display:block}._2PIs8{color:#484848;font-family:inherit;margin:0;word-wrap:break-word;line-height:18px;letter-spacing:.2px;padding-top:0;padding-bottom:0;display:inline}._1oPXx,._3JZQl,.BFDSM{font-size:15px}._3JZQl{margin-top:8px!important}._1V7dM{font-weight:200;font-size:14px;color:#767676}._2hrxW{position:absolute;top:10px;right:10px}._2CBpD{font-size:36px;color:#fff}._1CnLU,._2CBpD:focus,._2CBpD:hover{color:#ff7e82}._1Xja3{display:block;fill:#fff;height:45px;width:45px;font-size:45px}@media screen and (max-width:1280px){._2mCtN{height:200px}}@media screen and (max-width:800px){._2mCtN{height:345px}}@media screen and (max-width:480px){._2mCtN{height:215px}}.oNfKQ{background-color:#767676}.JZc3P,.oNfKQ{min-height:600px;width:100%}.JZc3P{background-color:#ccc}._1jyYA{width:100%;position:relative}._21nBZ{width:100%;position:absolute;top:0;min-height:200px;background:#484848}._1dUwG{min-height:600px;background-color:#ff7e82;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_3ydpW",
	"container": "_2rVw2",
	"textEllipsis": "_4zDOk",
	"listItemContainer": "_1t4MT",
	"listPhotoContainer": "_1vJPL",
	"listPhotoCover": "_2mCtN",
	"listPhotoMedia": "_1vCWJ",
	"imgResponsive": "_2f9aJ",
	"listInfo": "_3WyXw",
	"listInfoLink": "_2T3KM",
	"infoText": "_2PIs8",
	"infoPrice": "BFDSM",
	"infoReview": "_1oPXx",
	"infoTitle": "_3JZQl",
	"infoDesc": "_1V7dM",
	"wishListContainer": "_2hrxW",
	"wishListBtn": "_2CBpD",
	"activeWishList": "_1CnLU",
	"navigationIcon": "_1Xja3",
	"photoContainer": "oNfKQ",
	"detailsContainer": "JZc3P",
	"bookItContainer": "_1jyYA",
	"bookItBox": "_21nBZ",
	"hostContainer": "_1dUwG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/contact/Contact.css
// module id = 2617
// module chunks = 15